<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="legend"
    :data-field="externalKey"
  >
    <p
      class="legend__value"
      :class="classNames"
      v-html="value"
    />
    <p class="legend__description">
      <slot />
    </p>
  </div>
  <!-- eslint-enable vue/no-v-html -->
</template>

<script>
export default {
  name: 'BlockLegend',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    externalKey: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    classNames: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.legend {
  line-height: 1.3;
  margin-bottom: 1.5rem;

  &__value {
    font-family: $font-family-base;
    font-size: calcEm(36px);
    margin-bottom: 0;

    &_medium {
      font-size: calcEm(32px);
    }

    &_medium-2 {
      font-size: calcEm(28px);
      text-align: center;
    }

    &_small-1,
    &_small-2 {
      font-family: $font-family-sans-serif;
    }

    &_small-1 {
      font-size: calcEm(18px);
    }

    &_small-2 {
      font-size: calcEm(16px);
    }

    &_block-center {
      padding: 5px 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }
  &__description {
    font-family: $font-family-sans-serif;
    font-size: calcEm(18px);
    margin-bottom: 0;

  }
}
</style>
